// @flow
import React, { PureComponent } from 'react';
import config from '../../../config';
import SelectSubscriptionPage from '../../../components/common/SelectSubscriptionPage';
import { FullButton, GradientPage, SecondaryFullButton } from '../../../components/common';
import I18n from '../../../lib/i18n';

import type { NavigationRoute, NavigationScreenProp } from '@react-navigation/compat';
import type { Subscription } from 'digicel-kaizen-library';

export default class SelectSubscriptionToActivatePage extends PureComponent<Props> {
  goToSimSwap = () => this.props.navigation.navigate('selectSubscriptionToSwapSim');

  renderPrimaryButton = (props: Object): any => (
    <FullButton
      text={I18n.t('SignUp.SelectSubscriptionToActivatePage.button')}
      isLoading={this.props.isLoading}
      {...props}
    />
  );

  renderSecondaryButton = (props: Object): any =>
    this.props.hasSubscriptionsToSwap && config.canSwapSim ? (
      <SecondaryFullButton
        text={I18n.t('SignUp.SelectSubscriptionToActivatePage.swapSim')}
        onPress={this.goToSimSwap}
        {...props}
      />
    ) : null;

  render() {
    return (
      <GradientPage iosEdges={['top','bottom']}>
        <SelectSubscriptionPage
          title={I18n.t('SignUp.SelectSubscriptionToActivatePage.title')}
          subscriptions={this.props.subscriptions}
          PrimaryButton={this.renderPrimaryButton}
          onPressPrimaryButton={this.props.onConfirm}
          SecondaryButton={this.renderSecondaryButton}
          canCreateNewLine
          isActivation={true}
          setSubscriptionToUpdate={this.props.setSubscriptionToUpdate}
        />
      </GradientPage>
    );
  }
}

export type DispatchProps = {
  onConfirm: (?Subscription) => any,
  setSubscriptionToUpdate: Function,
};
export type StateProps = {
  hasSubscriptionsToSwap: boolean,
  isLoading: boolean,
  setSubscriptionToUpdate?: Function,
  subscriptions: Subscription[],
};

type Props = DispatchProps & StateProps & { navigation: NavigationScreenProp<NavigationRoute> };
